
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/privacy",
      function () {
        return require("private-next-pages/de/privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/privacy"])
      });
    }
  